import React  from 'react';
const value = {
  path:"mortgage_broker",
  title:"Mortgage Broker",
  date_modified:"June 2020",
  date_created:"June 2020",
  content:
[
<p align="justify">
Once you have an idea of your maximum house price and affordability per month, it will be time to get pre-approved for a mortgage. Mortgage brokers provide benefit by finding lenders offering better rates and better conditions, than you would have been able to procure on your own. Mortgage brokers are licensed financial professionals. To put it simply, their job is to compare mortgages from a variety of lenders and identify the ones best suited for the applicant(s). This is different from a mortgage/loan specialist you might find at a bank, who can only discuss offerings from their associated company. Using a broker often results in less leg work on the part of the mortgagor, and a more favourable mortgage. Since mortgage brokers have relationships with multiple types of lenders, they can be specifically helpful to buyers who don’t qualify for mortgages from traditional lenders, such as banks.
</p>
,
<p align="justify">
Mortgagors must be weary when using a broker, though. Brokers usually get paid via commission from the lenders; meaning they could be motivated to provide you with a mortgage that will pay them a higher commision -- and not necessarily be the best mortgage for you. It’s possible to avoid such behavior via borrower-paid compensation -- where the borrower pays the broker, instead of the lender. You can also try to determine if your broker has your best interests at heart by doing a little investigation:
</p>
,
<ul>
  <li>They should have worked with a minimum of 7 lenders over the past year.</li>
  <li>Typical commision for a 5-year term is around 1%; if it’s much higher, there might be other deals at play.</li>
  <li>Less than half of their clients should have mortgages with their top lender.</li>
</ul>
,
<p align="justify">
You don’t need to use a mortgage broker, you can just as easily go from lender to lender looking for the best rate, but using a mortgage broker will often result in better terms for you. When it comes time to decide, pay attention to not only the costs of the mortgage, but lender fees as well.
</p>

],
  tags:["mortgage","real estate professionals"]
}

export default value



// WEBPACK FOOTER //
// src/content/mortgageBroker.js